import React, { useEffect } from "react";
import PaymentDue from "@/Assets/Others/PaymentDue.svg?url";
import { ZTypography } from "@atoms";
import { FontWeights } from "@atoms/ZTypography";
import BannerNotificationActionCreators from "@/Actions/BannerNotification";
import useDispatch from "@/Components/Utils/useDispatch";
import { GlobalState } from "@/Reducers/interface";
import { useSelector } from "react-redux";
import { BillingStatusEnum, ZomentumRoutes } from "@/Contracts";
import { isDocumentClientView } from "@/Contracts/Utils";
import { useRouteMatch } from "react-router-dom";

const ZPaymentDueBanner: React.FC = () => {
	const dispatch = useDispatch();
	const isEndClientView = isDocumentClientView(location.pathname);
	const isPdfView = useRouteMatch(ZomentumRoutes.DocumentsPdfView)?.isExact;
	const isSetupAccount = useRouteMatch(ZomentumRoutes.SetupAccount)?.isExact;

	const { isPaymentDueBannerOpen, isBannerOpen, isTrialPaymentOverDue } =
		useSelector((state: GlobalState) => ({
			isPaymentDueBannerOpen:
				state.bannerNotification.isPaymentDueBannerOpen,
			isBannerOpen: state.bannerNotification.isOpen,
			isTrialPaymentOverDue:
				state.user.billingInfo?.payment_source &&
				state.user.billingInfo?.billing_status ===
					BillingStatusEnum.TrialPaymentOverdue
		}));

	const handleBannerVisibility = visible => {
		dispatch(
			BannerNotificationActionCreators.togglePaymentDueBanner(visible)
		);

		const appNavBar = document.getElementsByClassName(
			"app-sider ant-layout-sider"
		)[0] as HTMLElement;

		const navMenuSideBar = document.getElementsByClassName(
			"settings-sider"
		)[0] as HTMLElement;

		const rightDrawer = document.getElementsByClassName(
			"ant-drawer-right"
		)[0] as HTMLElement;
		if (visible) {
			if (appNavBar && navMenuSideBar) {
				appNavBar.style.marginTop = "7.5rem";
				appNavBar.style.minHeight = "calc(100vh - 40px)";
				navMenuSideBar.style.height = "calc(100vh - 4.5rem - 40px)";
			}
		} else {
			if (navMenuSideBar && appNavBar) {
				appNavBar.style.marginTop = "4.5rem";
				appNavBar.style.minHeight = "100vh";

				navMenuSideBar.style.height = "calc(100vh - 4.5rem)";
			}

			if (rightDrawer) {
				rightDrawer.style.top = "0px";
				rightDrawer.style.height = "100%";
			}
		}
	};

	useEffect(() => {
		if (isTrialPaymentOverDue) {
			if (!isBannerOpen) {
				const isBannerClosed = sessionStorage.getItem(
					"ZPaymentDueBannerClosed"
				);
				if (!isBannerClosed) {
					handleBannerVisibility(true);
				}
			} else {
				handleBannerVisibility(false);
			}
		}
	}, [isBannerOpen, isTrialPaymentOverDue]);

	const handleClose = () => {
		sessionStorage.setItem("ZPaymentDueBannerClosed", "true");
		handleBannerVisibility(false);
	};

	if (
		!isPaymentDueBannerOpen ||
		isEndClientView ||
		isPdfView ||
		isSetupAccount
	) {
		return null;
	}

	return (
		<div className="w-full h-10 bg-yellow-2 flex items-center px-8">
			<div className="flex items-center justify-center flex-grow">
				<img src={PaymentDue} alt="payment due" className="mt-1" />
				<ZTypography.ZText
					className="ml-5"
					level={0}
					weight={FontWeights.SEMIBOLD}
					colorVariant={9}
				>
					Your trial is ending soon. You will be charged after your
					trial period expires.
				</ZTypography.ZText>
			</div>
			<ZTypography.ZText
				className="cursor-pointer"
				level={0}
				weight={FontWeights.MEDIUM}
				colorVariant={7}
				onClick={handleClose}
			>
				Dismiss
			</ZTypography.ZText>
		</div>
	);
};

export default ZPaymentDueBanner;
